import { useQuery } from '@tanstack/react-query';
import { fetchAllShipmentProductLines } from '@/apis/shipment';

/** React Query key for every product line of one shipment. */
export const shipmentProductLinesKey = (shipmentId: string) =>
  ['shipment-product-lines', shipmentId] as const;

/** Every product line of one shipment for the edit drawer, fetched once per opening; failures show inline, so no retries, and no focus or reconnect refetch moves the baseline mid-edit. */
export function useShipmentProductLinesQuery(
  shipmentId: string,
  enabled: boolean
) {
  return useQuery({
    queryKey: shipmentProductLinesKey(shipmentId),
    queryFn: () => fetchAllShipmentProductLines(shipmentId),
    enabled: enabled && Boolean(shipmentId),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
